import { createSlice } from '@reduxjs/toolkit';

export interface IFileType {
  content_size: number;
  created_at: string;
  created_by: string;
  db_id: string;
  file_host_id: number;
  hash: string;
  id: string;
  is_deleted: boolean;
  is_private: boolean;
  last_modified?: string;
  name: string;
  size: number;
  type: string;
  info?: {
    edit: string;
    size: number;
    server: number;
  };
}

export type DataType = {
  agree: boolean;
  agreement_at: string;
  agreement_type: string;
  brief_content: string;
  created_at: string;
  created_by: string;
  db_id: string;
  document_id: string;
  files: IFileType[];
  id: string;
  recipient_name: string;
  recipient_user_id: string;
};

type RequestCommandState = {
  loading: boolean;
  data: DataType[];
};

const initialState: RequestCommandState = {
  loading: false,
  data: [],
};

export const agreementListSlice = createSlice({
  name: 'agreementList',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default agreementListSlice.reducer;
